<ul class="stepper">
  @for (i of stepsArray(); track $index) {
    <li
      [class.current]="i === currentStep()"
      [class.completed]="i < currentStep()"
      [class.not-started]="i > currentStep()"
      (click)="onStepClicked(i)"
    >
      <span class="step-circle">
        @if (i >= currentStep()) {
          <span>{{ i }}</span>
        }
        @if (i < currentStep()) {
          <i class="icon icon-check2"></i>
        }
      </span>
      <span class="step-label">{{ steps().get(i) }}</span>
    </li>
  }
</ul>
